import axios from "axios";

// Servidor de ZUA (Supabase Edge Function "landings"). Los precios los decide el servidor con el catálogo de ZUA.
export const LANDINGS_URL =
  process.env.REACT_APP_LANDINGS_URL || "https://muefmaloeuzyzogjmqta.supabase.co/functions/v1/landings";

export const api = axios.create({ baseURL: LANDINGS_URL });

const idioma = () => document.documentElement.lang || "en";

// Identificador de visitante y campaña sólo si aceptó la medición en el banner de ZUA (zua-privacidad.js).
function medicion() {
  const d = window.ZUAPrivacidad && window.ZUAPrivacidad.decision ? window.ZUAPrivacidad.decision() : null;
  if (!d || !d.medicion) return { medicion: false };
  let visitante = null;
  let utm = {};
  try {
    visitante = window.localStorage.getItem("zua_visitante");
    utm = JSON.parse(window.sessionStorage.getItem("zua_utm") || "{}");
  } catch (e) {
    /* modo privado */
  }
  return { medicion: true, visitante, utm };
}

export const startPlanCheckout = (lookup_key) => api.post("/checkout", { lookup_key, idioma: idioma() });

export const startCustomCheckout = (service_ids) => api.post("/checkout-a-medida", { service_ids, idioma: idioma() });

export const getPaymentStatus = (sessionId) => api.get(`/estado/${sessionId}`);

export const submitEnterpriseRequest = (data) => api.post("/enterprise", { ...data, idioma: idioma(), ...medicion() });

export const quotePdfUrl = (sessionId, lang) => `${LANDINGS_URL}/cotizacion/${sessionId}?lang=${lang}`;

export const SERVICE_MENU = [
  { id: "sourcing", name: "Strategic Sourcing", price: 2500, unit: "proy.", testid: "checkbox-service-sourcing", desc: "Desde $2,500 / proy. · Market mapping, preselección, validación documental y shortlist. + Comisión de 3% a 7% sobre valor de compra si se gestiona el procurement." },
  { id: "factory_audit", name: "In-Situ Factory Audit", price: 1250, unit: "aud.", testid: "checkbox-service-factory-audit", desc: "$1,250 - $1,500 / aud. · Evaluación presencial de capacidad, calidad y scorecard fotográfico. Excluye viáticos fijos." },
  { id: "e2e_supply_chain", name: "E2E Supply Chain", price: 2500, unit: "mes", testid: "checkbox-service-e2e-supply-chain", desc: "Desde $2,500 / mes · Gestión integral E2E desde proveedor hasta destino final. Coordinación logística y de incidencias." },
  { id: "nearshoring_study", name: "Nearshoring Feasibility", price: 5000, unit: "proy.", testid: "checkbox-service-nearshoring-study", desc: "$5,000 - $7,500 / proy. · Estudio comparativo técnico/financiero vs. Asia, riesgos T-MEC y roadmap. Proyectos complejos desde $10,000." },
  { id: "pre_shipment", name: "Pre-Shipment Inspection", price: 700, unit: "insp.", testid: "checkbox-service-pre-shipment", desc: "$700 / insp. · Inspección visual previa al embarque, muestreo y evidencia. Inspectores externos: $200/día + viáticos." },
  { id: "logistics_audit", name: "Individual Logistics Audit", price: 1000, unit: "aud.", testid: "checkbox-service-logistics-audit", desc: "$1,000 / aud. · Análisis de rutas, lead times, costos críticos y optimización de fletes." },
];